export default [
    {
        "id": "site-map",
        "plugin": "ShopSiteMap",
        "pluginId": 14,
        "name": "ShopSiteMap",
        "html": require('./site-map/html').default,
        "css": require('./site-map/css').default,
        "scss": require('./site-map/scss').default,
        "cssMobile": require('./site-map/cssMobile').default,
        "scssMobile": require('./site-map/scssMobile').default,
        "cssTablet": require('./site-map/cssTablet').default,
        "scssTablet": require('./site-map/scssTablet').default,
        "js": require('./site-map/js').default,
        "minJs": require('./site-map/minJs').default
    }
]